import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Agent notifications.
 *
 * Perechile vechi: `settings/easeedesk/agent_notifications_settings`,
 * `agent_notifications_list/2`, `agent_event_notifications`,
 * `edit_agent_notifications`.
 *
 * Felul aplicatiei (2, agentul) nu se mai trimite din pagina: sta in serviciul
 * de pe api. Vezi `EaseedeskAgentNotifications`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface AgentNotificationEvent {
  ID: number
  event: string
  description: string
}

export interface AgentNotificationEvents {
  events: AgentNotificationEvent[]
}

export interface AgentNotificationTicketType {
  ID: number
  type_name: string
}

export interface AgentNotificationEventDetail {
  event_id: number
  ticket_types: AgentNotificationTicketType[]
  /** Tipurile bifate: randurile cu `status = 1`. */
  chosen: number[]
}

export interface AgentNotificationsShell {
  title: string
  moduleUrl: string
}

export function agentNotificationsShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'agent_notifications'],
    queryFn: () => apiGet<AgentNotificationsShell>('/settings/easeedesk/agent_notifications'),
  })
}

export function agentNotificationsListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'agent_notifications', 'list'],
    queryFn: () => apiGet<AgentNotificationEvents>('/settings/easeedesk/agent_notifications/list'),
  })
}

export function agentNotificationEventQuery(event: number) {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'agent_notifications', 'event', event],
    queryFn: () => apiGet<AgentNotificationEventDetail>(`/settings/easeedesk/agent_notifications/${event}`),
    enabled: event > 0,
  })
}

export function saveAgentNotifications(event: number, ticket_types: number[]) {
  return apiPost<{ ok?: boolean; chosen?: number[] }>(`/settings/easeedesk/agent_notifications/${event}`, {
    ticket_types,
  })
}
